// extracted by mini-css-extract-plugin
module.exports = {"marketsBody":"MarketBody_marketsBody__2AJWh"};